module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "loading text-muted"
  }, [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "col"
  }, [_vm._m(0), _vm._v(" "), _c('scatter-chart', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "chartdata": _vm.chartdata,
      "options": _vm.options
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "fixed",
      "right": "35px",
      "top": "10px"
    }
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', [_c('small', {
    staticClass: "text-muted mr-2"
  }, [_vm._v("LOW")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "10px",
      "height": "5px",
      "background-color": "#e5e5e5",
      "border-radius": "10px 0 0 10px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "5px",
      "background-color": "#e5e5e5",
      "font-size": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-4px"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "10px",
      "height": "5px",
      "background-color": "#e5e5e5",
      "border-radius": "0 10px 10px 0"
    }
  }), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted ml-2"
  }, [_vm._v("HIGH")])])]), _vm._v(" "), _c('div', {
    staticClass: "row d-flex text-center"
  }, [_c('small', {
    staticClass: "text-muted text-center",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Typical")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75961a77"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/CostTonneKMWidget.vue
// module id = 741
// module chunks = 0